export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11840.e57da10e.jpg";